// extracted by mini-css-extract-plugin
export default {"container":"not-allowed-screen_container__yXm0d","card":"not-allowed-screen_card__FxQTL","text":"not-allowed-screen_text__-nNTU"};